import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Link,
} from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import TicketIcon from "../icons/TicketIcon";

// Map TicketTransactionTypes enum to readable strings
const getTransactionTypeString = (transactionType) => {
  const typeMap = {
    0: "Adjustment",
    1: "Daily Contests",
    2: "Streak",
    3: "Referral",
    4: "Raffle",
    5: "WinRaffle",
    6: "Refund",
    7: "Profile Completion Reward"
  };

  return typeMap[transactionType] || `Type ${transactionType}`;
};

export default function TicketTransactionsTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Reference</TableCell>
            <TableCell>Timestamp</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.transactions?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.transactionId}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.userId}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.email}
              </TableCell>
              <TableCell component="th" scope="row">
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <TicketIcon size={20} />
                  {row.amount}
                </div>
              </TableCell>
              <TableCell component="th" scope="row">
                {getTransactionTypeString(row.transactionType)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.reference}
              </TableCell>
              <TableCell component="th" scope="row">
                {fDateTime(new Date(row?.createdAt))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
